import { createRoute } from "@tanstack/react-router";

import { lazyWithRetry } from "@shared/lib/lazy";

import { renderProtectedRoute } from "@app/router/routeElements";
import { rootRoute } from "@app/router/rootRoute";

const rolesIndex = lazyWithRetry(() => import("./routes/roles"));
const usersPage = lazyWithRetry(() => import("./routes/users"));
const gdprPage = lazyWithRetry(() => import("./routes/gdpr"));
const securityIndex = lazyWithRetry(() => import("./routes/index"));

const securityIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/security",
  component: () =>
    renderProtectedRoute(securityIndex, { requirePerms: ["settings:read"] }),
});

const rolesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/security/roles",
  component: () =>
    renderProtectedRoute(rolesIndex, { requirePerms: ["settings:read"] }),
});

const usersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/security/users",
  component: () =>
    renderProtectedRoute(usersPage, { requirePerms: ["settings:read"] }),
});

const gdprRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/security/gdpr",
  component: () =>
    renderProtectedRoute(gdprPage, { requirePerms: ["settings:read"] }),
});

export const securityRouteTree = [
  securityIndexRoute,
  rolesRoute,
  usersRoute,
  gdprRoute,
];
